import clsx from 'clsx';
import React, { ReactNode } from 'react';

interface TableCellProps {
  children: ReactNode;
  className?: string;
}

const TABLE_CELL_BASE_STYLE = 'py-12 font-suisse-intl text-button-md pr-8';

const TableCell = ({ children, className }: TableCellProps) => (
  <td className={clsx(TABLE_CELL_BASE_STYLE, className)}>
    <table className="w-full table-fixed">
      <tbody>
        <tr>
          <td className="overflow-hidden text-ellipsis whitespace-nowrap">{children}</td>
        </tr>
      </tbody>
    </table>
  </td>
);

export default TableCell;
